// import { Injectable } from '@angular/core';
// import {
//   CanActivate, Router,
//   ActivatedRouteSnapshot,
//   RouterStateSnapshot
// } from '@angular/router';
// import { AuthService } from '../auth/auth.service';

// @Injectable()
// export class AuthGuard implements CanActivate {
//   constructor(private authService: AuthService, private router: Router) {
//   }

//   canActivate(): boolean {
//     if (this.authService.isLoggedIn()) {
//       // User is logged in, allow access
//       return true;
//     } else {
//       // User is not logged in, redirect to login page
//       this.router.navigate(['/login']);
//       return false;
//     }
//   }

//   // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
//   //   let url: string = state.url;
//   //   return this.checkLogin(url);
//   // }

//   // checkLogin(url: string): boolean {
//   //   let status = sessionStorage.getItem('Status')
//   //   if (status) {
//   //     return true; }

//   //   // Store the attempted URL for redirecting
//   //   this.authService.redirectUrl = url;

//   //   // Navigate to the login page with extras
//   //   // this.router.navigate(['/login']);
//   //   // return false;
//   // }
// }
import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // First check if user is logged in
    // if (!this.authService.isLoggedIn()) {
    //   this.router.navigate(['/login']);
    //   return false;
    // }

    // Get the URL path
    const url = state.url;
    
    // Get designation name from sessionStorage
    const desigName = JSON.parse(sessionStorage.getItem('DesigName'));
    
    // Define route permissions
    const restrictedRoutes = {
      '/main/cart/payment-checkout': ['Commercial','SCM']
    };

    // Check if current URL is restricted
    for (const restrictedUrl in restrictedRoutes) {
      if (url.includes(restrictedUrl)) {
        const allowedDesignations = restrictedRoutes[restrictedUrl];
        
        if (!allowedDesignations.includes(desigName)) {
          alert('Unauthorized: You do not have permission to access this page');
          this.router.navigate(['/main/home']);
          return false;
        }
        break;
      }
    }

    // Allow access
    return true;
  }
}